import { useMemo } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { CardMenuIcon } from '../../../features/cardMenu';
import InstructorList from '../../../components/InstructorList';
import { OverviewContent } from './OverviewContent';
import { OverviewModalDescriptionSection } from './OverviewModalDescriptionSection';
import { useOverviewNavigation } from '../overviewRouting';
import { mapShortProfessorToProfessor } from '../../shortContent/shortContentUtils';
import { useStartShort } from '../../shortContent/shortContentQueries';
import Raven from 'raven-js';
import getLang from 'academy-common-lib/utils/getLang';
import { ACLearningContentTimeReadout } from 'academy-common-lib/features/cards/components/ACLearningContentTimeReadout';
import { useLearningContentCardModels } from 'academy-common-lib/features/cards/hooks/useLearningContentCardModels';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShortOverviewModal = ({
  shortId,
  source,
  allowFullWidthChildren,
  playlistId
}) => {
  const {
    goTo
  } = useOverviewNavigation();
  const {
    cardModels,
    cardModelsLoading: loading,
    cardModelsError: error
  } = useLearningContentCardModels({
    items: [{
      id: shortId,
      type: 'SHORT_FORM_CONTENT'
    }]
  });
  const short = cardModels === null || cardModels === void 0 ? void 0 : cardModels[0];
  const language = (short === null || short === void 0 ? void 0 : short.language) || getLang();
  const [startShort] = useStartShort(shortId, language, playlistId);
  const professors = useMemo(() => {
    if (!short) return [];
    return short.professors.map(mapShortProfessorToProfessor(language));
  }, [short, language]);
  const handleChangeSelectedLanguage = ({
    target: {
      value
    }
  }) => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-change-language',
      appearsIn: source,
      trackId: shortId,
      name: short ? short.name : null,
      previousLanguage: language,
      newLanguage: value
    });
    goTo({
      id: shortId,
      type: 'SHORT_FORM_CONTENT',
      language: value
    });
  };
  const handleEnroll = () => {
    UsageTracker.track('interaction', {
      action: 'overview-modal-enroll',
      appearsIn: source,
      contentLanguage: language,
      contentType: 'SHORT',
      shortId,
      name: short ? short.name : null
    });
  };
  const handleOrganisationUrlClick = (professorId, organisation, organisationUrl) => () => {
    UsageTracker.track('interaction', {
      action: 'professor-organisation-click',
      contentType: 'SHORT',
      appearsIn: 'short-overview-curriculum',
      organisation,
      organisationUrl,
      professorId,
      shortId
    });
  };
  const handleOnVideoProgress = () => {
    var _short$progress;
    if ((short === null || short === void 0 || (_short$progress = short.progress) === null || _short$progress === void 0 ? void 0 : _short$progress.status) !== 'COMPLETED') {
      startShort().catch(Raven.captureException.bind(Raven));
    }
  };
  return /*#__PURE__*/_jsxs(OverviewContent, {
    allowFullWidthChildren: allowFullWidthChildren,
    assetLanguage: language,
    autoplay: false,
    error: error,
    fallbackThumbnailUrl: short && short.previewThumbnailRectangleUrl,
    headerIcons: /*#__PURE__*/_jsx(CardMenuIcon, {
      item: {
        id: shortId,
        type: 'SHORT_FORM_CONTENT',
        language
      }
    }),
    loading: loading,
    onVideoProgress: handleOnVideoProgress,
    shortId: shortId,
    children: [/*#__PURE__*/_jsx(OverviewModalDescriptionSection, {
      description: short && short.description,
      duration: short && /*#__PURE__*/_jsx(ACLearningContentTimeReadout, {
        item: short
      }),
      id: shortId,
      onChangeSelectedLanguage: handleChangeSelectedLanguage,
      onEnroll: handleEnroll,
      selectedLanguage: language,
      title: short && short.name,
      type: "SHORT_FORM_CONTENT"
    }), !!professors.length && /*#__PURE__*/_jsx(InstructorList, {
      handleOrganisationUrlClick: handleOrganisationUrlClick,
      language: language,
      padding: "800",
      professors: professors
    })]
  });
};
export default ShortOverviewModal;